import React from "react";
import { BatchDownloadItem, Status } from "../../type";
import { Item } from "../Item";
import "./index.less";

interface IProps {
  list: BatchDownloadItem[];
  callback: (item: any) => void;
}

const List = (props: IProps) => {
  const { list, callback } = props;
  // console.log(list, 'listlistlistlistlist');
  return (
    <div className="download-list">
      {list.map((item: BatchDownloadItem) => {
        return (
          <Item
            key={item.id}
            id={item.id}
            title={item.title}
            currentSize={item.currentSize}
            currentProgress={item.currentProgress}
            size={item.size}
            imgUrl={item.imgUrl}
            status={item.status}
            type={item.type}
            callback={(applyFnName: Status) => {
              callback({ ...item, applyFn: applyFnName });
            }}
          />
        );
      })}
    </div>
  );
};

export default List;
